export default __webpack_public_path__ + "static/media/twicelogo.a1685ec7.jpg";